export const actionTypes = {
    authStartCheckingSession: '[Auth] Start Checking Session',
    authFinishCheckingSession: '[Auth] Finish Checking Session',
    authLoadSession: '[Auth] Load Session',
    authErrorCheckingSession: '[Auth] Error Checking Session',
    authForceChangePassword: '[Auth] Force Change Password',
    authStartCheckingLogin: '[Auth] Start Checking Login',
    authFinishCheckingLogin: '[Auth] Finish Checking Login',
    authInitializingLogin: '[Auth] Initializing Login',
    authLoadDataLogin: '[Auth] Login',
    authErrorLogging: '[Auth] Error Login',
    authPasswordChangeRequired: '[Auth] Password Change Required',
    authStartCreatingNewPassword: '[Auth] Start Creating New Password',
    authFinishCreatingNewPassword: '[Auth] Finish Creating New Password',
    authLogout: '[Auth] Logout',

    // COMPANIES

    compLoadingStartSingle: '[Comp] Checking Start Companie',
    compLoadingFinishSingle: '[Comp] Checking Finish Companie',
    compLoadCompanyById: '[Comp] Checking Start Companie',
    compLoadCompanyByIdError: '[Comp] Ocurred Error Companie',
    compLoadCompany: '[Comp] Load Companie By-ID',
    compLoadingStart: '[Comp] Checking Start Companies',
    compLoadingFinish: '[Comp] Checking Finish Companies',
    compGetCompanies: '[Comp] Get Companies BY-ID',
    compLoadCompanies: '[Comp] Load Companies By-ID',
    compLoadingStartGetAllCompanies: '[Comp] Get Companies',
    compLoadingFinishGetAllCompanies: '[Comp] Finish Load Companies',
    compLoadAllCompanies: '[Comp] Load All Companies',
    compSaveCompanySelected: '[Comp] Save Company',

    compInsertStart: '[Comp] Load Save Companies',
    compFinishInsertStart: '[Comp] Load Finish Companies',

    compDeleteStart: '[Comp] Load Delete Companies',
    compFinishDelete: '[Comp] Finish Delete Companies',
    compDeleteCompany: '[Comp] Delete Companies',

    compUpdateStart: '[Comp] Update Load Companies',
    compFinishUpdate: '[Comp] Update Finish Companies',
    compUpdateCompany: '[Comp] Update Companies',

    // Approval Rules
    approvalStart: '[Approval] Start Load Approval',
    approvalFinish: '[Approval] Finish Fetch Approval',
    approvalLoadApproval: '[Approval] Load Approval Success',
    approvalError: '[Approval] Error Fetch Approval',
    saveApprovalStart: '[Approval] Start Save Approval',
    saveApprovalFinish: '[Approval] Finish Save Approval',
    saveApprovalSuccess: '[Approval] Success Save Approval',
    saveApprovalError: '[Approval] Error Save Approval',
    approvalStartByID: '[Approval] Start Load ApprovalByID',
    approvalFinishByID: '[Approval] Finish Fetch ApprovalByID',
    approvalLoadApprovalByID: '[Approval] Load Approval SuccessByID',
    approvalErrorByID: '[Approval] Error Fetch ApprovalByID',
    approvalStartUpdate: '[Approval] Start Update Approval',
    approvalFinishUpdate: '[Approval] Finish Update Approval',
    approvalLoadUpdate: '[Approval] Load Update Approval',
    approvalErrorUpdate: '[Approval] Error Update Approval',


    // GROUP
    groupInsertStart: '[Group] Start Load Save Group',
    groupFinishInsert: '[Group] Finish Load Save Group',
    groupErrorInsert: '[Group] Error Save Group',

    groupUpdateStart: "[Group] Start Load Update Group",
    groupErrorUpdate: "[Group] Finish Load Update Group",
    groupFinishUpdate: "[Group] Error Update Group",

    // SERVICE
    floStartAddingNewService: '[Service] Loading Start Add Service',
    floFinishAddingNewService: '[Service] Loading Finish Add Service',
    floAddNewServiceError: '[Service] Error Start Service',
    ServiceUpdateStart: '[Service] Loading Start Update Service',
    ServiceFinishUpdate: '[Service] Loading Finish Update Service',
    ServiceUpdate: '[Service] Loading Updated Service',
    ServiceUpdateError: '[Service] Loading Error Update Service',

    //Supplier and create user_spplier
    floStartAddingNewProveedor: '[Proveedor] Loading Start Add Proveedor',
    floFinishAddingNewProveedor: '[Proveedor] Loading Finish Add Proveedor',
    floAddNewProveedorError: '[Proveedor] Error Updating Proveedor',
    supplier: '[Supplier] Set Data Exist Supplier Or User',
    token: '[Supplier] Set Token',

    supplierUpdateStart: '[Supplier] Update Load Supplier',
    supplierFinishUpdate: '[Supplier] Update Finish Supplier',
    supplierUpdate: '[Supplier] Update Supplier',
    supplierUpdateError: '[Supplier] Update Error Supplier',

    supplierFetchStart: '[Supplier] List Load Suppliers',
    supplierFetchSuccess: '[Supplier] List Finish Suppliers',
    supplierFetchError: '[Supplier] List Error Suppliers',

    supplierLoadingStartSingle: '[Supplier] Checking Start Supplier',
    supplierLoadingFinishSingle: '[Supplier] Checking Finish Supplier',
    supplierLoadSupplierById: '[Supplier] Checking Start Supplier',
    supplierLoadSupplierByIdError: '[Supplier] Ocurred Error Supplier',

    // floDeleteFlows: '[Flows] Delete Flows',
    floIsChangesPendingFlow: '[Flows] Is Changes Pending Flows',
    //FlowsInEdition
    floChangeFlowInEdition: '[Flows] Change Flow In Edition',

    // floGetExecutionsByFlow: '[Flows] GetExecutionsByFlow',
    floErrorManageFlows: '[Flows] Error Flows',

    settiStartLoadingSettingsFlows: '[Settings] Start Loading Settings Flows',
    settiFinishLoadingSettingsFlows: '[Settings] Finish Loading Settings Flows',
    settiLoadAllSettingsFlows: '[Settings] Load All Settings Flows',
    settiStartUpdatingSettingsFlows: '[Settings] Start Updating Settings Flows',
    settiFinishUpdatingSettingsFlows: '[Settings] Finish Updating Settings Flows',
    settiStartDeletingSettingsFlow: '[Settings] Start Deleting Settings Flows',
    settiFinishDeletingSettingsFlows: '[Settings] Finish Deleting Settings Flows',
    settiStartAddingSettingsFlows: '[Settings] Start Adding Settings Flow',
    settiFinishAddingSettingsFlow: '[Settings] Finish Adding Settings Flow',
    settiErrorSettingFlows: '[Settings] Error Settings Flows',

    staStartLoadingStatus: '[Status] Start Loading Status',
    staFinishLoadingStatus: '[Status] Finish Loading Status',
    staLoadStatus: '[Status] Load Status',
    staStartUpdatingStatus: '[Status] Start Updating Status',
    staFinishUpdatingStatus: '[Status] Finish Updating Status',
    staStartDeletingStatus: '[Status] Start Deleting Status',
    staFinishDeletingStatus: '[Status] Finish Deleting Status',
    staStartAddingStatus: '[Status] Start Adding Status',
    staFinishAddingStatus: '[Status] Finish Adding Status',
    staErrorStatus: '[Status] Error Status',

    tracStartLoadingStatusAllFlows: '[Traceability] Start Loading Status All Flows',
    tracFinishLoadingStatusAllFlows: '[Traceability] Finish Loading Status All Flows',
    tracLoadStatusAllFlows: '[Traceability] Load Status All Flows',
    tracStartLoadingExecutionsByFlow: '[Traceability] Start Loading Executions By Flow',
    tracFinishLoadingExecutionsByFlow: '[Traceability] Finish Loading Executions By Flow',
    tracLoadExecutionsByFlow: '[Traceability] Load Executions By Flow',
    tracErrorTraceability: '[Traceability] Error Traceability',

    LoadSelectedFlow: '[load Selected Flow]',

    // floGetSchemesFlows: '[Flows] Get Schemes',
    GetSchemes: '[Flows] Get Schemes ',
    getFunctionsSchema: '[Flows] Get Functions Schemes',

    //GetSchemes: '[Flows] Get Schemes ',
    GetBoardUrl: '[Flows] Get Boards Url ',
    getListTypesComponent: '[Flows] Get List Types Component',

    //Get Documents
    loadAllDocs: '[Docs] Load All Docs',
    counter: 'COUNTER',
    loadHistory: '[Docs] Load History',
    isLoadingLoadAllDocs: '[Docs] Is Loading Load All Docs',

    //GetIdFlowProcesss
    LoadAllConfiguration: '[Config] Load All Config',
    LoadingConfiguration: '[Config] Start All Config',
    LoadingConfigurationError: '[Config] Error All Config',

    SaveConfigurationSuccess: '[Config] Load Save Config',
    SaveConfigurationError: '[Config] Error Save Config',
    SavingConfiguration: '[Config] Start Save Config',

    UpdatingConfiguration: '[Config] Load Start Config',
    UpdateConfigurationSuccess: '[Config] Load Updated Config',
    UpdateConfigurationError: '[Config] Load Error Config',

    //Get Menu
    loadMenu: '[Menu] Load Menu',

    //Manage Users
    loadAllUsers: '[Users] Load All Users',
    isLoadingLoadAllUsers: '[Docs] Is Loading Load All Users',
    loadAllPermissions: '[Users] Load All Permissions',
    isLoadingAllPermissions: '[Docs] Is Loading All Permissions',
    loadCompaniesPermissions: '[Users] Load Companies Permissions',
    loadGroupsPermissions: '[Users] Load Groups Permissions',

    notificaction: '[Mes] Notification',

    //Manage Signature Docs
    loadDataSignatureDoc: '[Sign] Data Signature Doc',
    isLoadingDataSignatureDoc: '[Sign] Is Loading Data Signature Doc',

    // session State
    sessionStateLoadStart: '[SessionState] Start Load',
    sessionStateLoadFinish: '[SessionState] Finish Load',
    companyConfigLoadCompanies: '[SessionState] Load Companies',
    companyConfigSetSelected: '[SessionState] Set Selected Company',
    companyConfigError: '[SessionState] Error',
    companyConfigStartViewAs: '[SessionState] Start View As',
    companyConfigSetViewAsCompany: '[SessionState] Set View As Company',
    companyConfigEndViewAs: '[SessionState] End View As',
    companyConfigSetConfigurationData: '[SessionState] Set Configuration Data',
    sessionStateChangesPending: '[SessionState] Changes Pending',
    sessionStateActionPending: '[SessionState] Action Pending',
    sessionStateActionRequired: '[SessionState] Action Required',

    //Tables shared and shared views
    resetInitState: '[TableShared] Reset Init State',
    setIdUserAction: '[TableShared] Set Id User Action',
    setIdCompany: '[TableShared] Set Id Company',
    isSelectCompany: '[TableShared] Is Select Company',
    getListDetails: '[TableShared] Get Details',
    getColumnsTableDetails: '[TableShared] Get Columns',
    getConfigurationTableDetails: '[TableShared] Get Configuration',
    isLoadingListDetails: '[TableShared] Is Loading Details',
    rowsChecked: '[TableShared] Rows Checked',
    filterAndPagination: '[TableShared] Filters And Pagination',
    checkInTable: '[TableShared] Check In Table',
    rowsCheckedDetails: '[TableShared] Rows Checked Details',
    infoSudMenu: '[TableShared] Info Sud Menu',
}